import { MktTaggingTransformationService } from 'src/app/core/services/mkt-tagging-transformation.service';
import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { MktSEOService } from 'src/app/core/services/mkt-seo.service';
import { MktSiteCatalystService } from 'src/app/core/services/mkt-site-catalyst.service';
import { Subscription } from 'rxjs';
import { OfferUtilService } from 'src/app/common/services/offer-util.service';
import { MktDynamicOfferService } from 'src/app/core/services/mkt-dynamic-offer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-credit-card-conversion',
  templateUrl: './credit-card-conversion.component.html',
  styleUrls:["./credit-card-conversion.component.scss"],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class CreditCardConversionComponent implements OnInit {
  private pageType: string = 'costco-credit-card-conversion';
  public content: any;
  private scData: any;
  public pageNotFound: boolean;
  public isBrowser: boolean;
  sub: Subscription = new Subscription();
  seoTags: any;
  private pricingDetails: any = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private _mktContentService: MktContentService,
    private contentStorageService: MktContentStorageService,
    private router: Router,
    private _offerUtilService: OfferUtilService,
    private siteCatService: MktSiteCatalystService,
    private titleService: Title,
    private mktSEOService: MktSEOService,
    private _mktTagging: MktTaggingTransformationService,
    private mktDynamicOfferService: MktDynamicOfferService,
  ) {
    this._mktContentService.microsite.next(true);
  }

  ngOnInit() {
    this.checkBundleLoaded();
    !this.pageNotFound && this.sub.add(this.mktDynamicOfferService.getPriceDetails().subscribe((priceDetails = []) => {
        // Pricing placeholder replacement handle
        if (priceDetails.length === 0) { this.pageNotFound = false; return;}
        this.pricingDetails = priceDetails;
        this.getDynamicUrls();  
    }));
  }

  private async checkBundleLoaded(){
    const contentObj = this.contentStorageService.get('Microsites', 'copy', this.pageType);
    if(!contentObj) this.router.navigateByUrl('page-not-found');
      this.initilize(contentObj);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  async commonOnInit(contentObj: any) {
    if (contentObj?.TEXT) {
      this.scData = JSON.parse(contentObj.siteCatalyst || '{}');
      if (this.scData) {
        this.scData.pageName = "Costco Card - Cash Back Reward Microsite";
        this.scData.channel = "us";
        this.scData.siteSection4 = "costco cash back microsite";
      }
      this.content = JSON.parse(contentObj.TEXT || '{}');
      this.titleService.setTitle(this.content.pageTitle);
      this.seoTags = JSON.parse(contentObj.seoTags || '{}');
      if (this.seoTags) this.mktSEOService.setContentfulSeoTags(this.seoTags);
    }
  }

  initTaggingTransformation() {
    this._mktTagging.tagMktCompareCards("cards-costco-landing", {
    });
  }

  async initilize(contentObj: any) {
    await this.commonOnInit(contentObj);
    if (!isPlatformServer(this.platformId)) {
      this.isBrowser = true;
      this.getDynamicOffer();
      this.initTaggingTransformation();
      if (this.scData) this.siteCatService.callSC('naAnalyticsPageView', this.scData);
    }
  }

  private getDynamicOffer() {
    if (isPlatformServer(this.platformId)) return;
    this._offerUtilService
      .getAllDynamicOffer({
        pageId: 'CitiCCPNGA',
        affinityId: '1C2',
        category: '',
        screenId: '',
        intc: ''
      }, (message) => {
        console.log(`>>> Microsite : Price Load ${message}`)
      });
  }

  private getDynamicUrls() {
    this.content.banner.links.map(async link => {
      const product = this.pricingDetails.filter(({ productIdentifier }) => (link.pid === productIdentifier))[0];
      if (product) link.url = product["terms-link"];
    });
    const additionalInfo = this.pricingDetails.filter(({ productIdentifier }) => (this.content.benefits.additionInformation.pid === productIdentifier))[0];
    if (additionalInfo) this.content.benefits.additionInformation.url = additionalInfo["terms-link"];
    this.pageNotFound=false;
  }

}
